// components/Surveys/MultiChoiceInput.js
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  font: 16px/1.4 'Inter', sans-serif;
  color: #161616;

  &:last-child {
    border-bottom: none;
  }
`

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  position: relative;
  cursor: pointer;

  &:checked {
    background: #28aae1;
    border-color: #28aae1;
  }
  &:checked::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 0;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`

/**
 * @param {{
 *   options: Array<{ id: string|number; label: string }>;
 *   otherEnabled?: boolean;
 *   value: string[];               // array de labels selecionadas
 *   onChange: (labels: string[]) => void;
 * }} props
 */
export default function MultiChoiceInput({
  options = [],
  otherEnabled = false,
  value = [],
  onChange
}) {
  const selected = new Set(value)

  const toggle = label => {
    if (selected.has(label)) {
      onChange(value.filter(v => v !== label))
    } else {
      onChange([...value, label])
    }
  }

  return (
    <Container>
      {options.map(opt => (
        <OptionLabel key={opt.id}>
          <Checkbox
            name="multi-choice"
            checked={selected.has(opt.label)}
            onChange={() => toggle(opt.label)}
          />
          {opt.label}
        </OptionLabel>
      ))}

      {otherEnabled && (
        <OptionLabel>
          <Checkbox
            name="multi-choice"
            checked={selected.has('Outro')}
            onChange={() => toggle('Outro')}
          />
          Outro
        </OptionLabel>
      )}
    </Container>
  )
}
